import { IStackStyles, IStackTokens, Shimmer, Stack } from "@fluentui/react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Divider } from "@mui/material";
import { shimmerWithElementGapRow } from "../../helper/ShimmerElement";
import { IPartnerDetailsProps } from "../../interfaces/PartnerView.interfaces";
import { PartnerDetailsStyles } from "./Styles/PartnerDetails.styles";
import { shimmerColor } from "../../constants/PartnerView.constants";
import { wordWrapStyle } from "../CustomerView/CustomerDetails.styles";
import { formatCountWithCommas } from "../../Utils/js-common";

export default function PartnerDetails(props: IPartnerDetailsProps) {
  const stackTokens: IStackTokens = { childrenGap: 10 };
  const labelStyles: IStackStyles = {
    root: {
      color: "#000000ff"
    }
  };

  return (
    <>
      <div
        style={{
          lineHeight: 2,
          minWidth: 230,
          paddingLeft: 15,
          paddingRight: 7
        }}
      >
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType1}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span className={PartnerDetailsStyles.StackStyleType1}>CPOR Tenant Count </span>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType2}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span
                style={wordWrapStyle}
              >
                :&nbsp;{formatCountWithCommas(props.Details?.cporTenantCount)}
              </span>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType1}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span className={PartnerDetailsStyles.StackStyleType1}>CSP Tenant Count </span>
            </Stack>
          )}

          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType2}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span
                style={wordWrapStyle}
              >
                :&nbsp;{formatCountWithCommas(props.Details?.cspTenantCount)}
              </span>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType1}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span className={PartnerDetailsStyles.StackStyleType1}>PAL Tenant Count </span>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType2}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span
                style={wordWrapStyle}
              >
                :&nbsp;{formatCountWithCommas(props.Details?.palTenantCount)}
              </span>
            </Stack>
          )}
        </Stack>
      </div>
      <Divider orientation="vertical" flexItem style={{ marginBottom: "20px" }} />
      <div
        style={{
          lineHeight: 2,
          minWidth: 230,
          paddingLeft: 15,
          paddingRight: 7
        }}
      >
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType1}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span className={PartnerDetailsStyles.StackStyleType1}>CPOR Login MAU</span>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType2}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span
                style={wordWrapStyle}
              >
                :&nbsp;{formatCountWithCommas(props.Details?.cporLoginMAU)}
              </span>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType1}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span className={PartnerDetailsStyles.StackStyleType1}>CSP Login MAU</span>
            </Stack>
          )}

          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType2}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span
                style={wordWrapStyle}
              >
                :&nbsp;{formatCountWithCommas(props.Details?.cspLoginMAU)}
              </span>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType1}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span className={PartnerDetailsStyles.StackStyleType1}>PAL Login MAU</span>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType2}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span
                style={wordWrapStyle}
              >
                :&nbsp;{formatCountWithCommas(props.Details?.palLoginMAU)}
              </span>
            </Stack>
          )}
        </Stack>
      </div>
      <Divider orientation="vertical" flexItem style={{ marginBottom: "20px" }} />
      <div
        style={{
          lineHeight: 2,
          maxWidth: 150,
          minWidth: 150,
          paddingLeft: 15
        }}
      >
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType3}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span className={PartnerDetailsStyles.StackStyleType2}>IsElite </span>
            </Stack>
          )}

          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType4}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span title={props.Details?.isElite ? "Elite partner" : "Not an elite partner"}>
                :&nbsp;{" "}
                {props.Details?.isElite === false ? (
                  <CloseIcon
                    titleAccess="false"
                    sx={{
                      color: "red",
                      fontSize: "1.3rem"
                    }}
                    className={PartnerDetailsStyles.IconStyle}
                  />
                ) : (
                  <CheckIcon
                    titleAccess="true"
                    sx={{
                      color: "green",
                      fontSize: "1.3rem"
                    }}
                    className={PartnerDetailsStyles.IconStyle}
                  />
                )}
              </span>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType3}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span className={PartnerDetailsStyles.StackStyleType2}>IsCPOR </span>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType4}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span title={props.Details?.isCPOR ? "CPOR Partner" : "No CPOR Partner"}>
                :&nbsp;{" "}
                {props.Details?.isCPOR === false ? (
                  <CloseIcon
                    titleAccess="false"
                    sx={{
                      color: "red",
                      fontSize: "1.3rem"
                    }}
                    className={PartnerDetailsStyles.IconStyle}
                  />
                ) : (
                  <CheckIcon
                    titleAccess="true"
                    sx={{
                      color: "green",
                      fontSize: "1.3rem"
                    }}
                    className={PartnerDetailsStyles.IconStyle}
                  />
                )}
              </span>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType3}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span className={PartnerDetailsStyles.StackStyleType2}>IsCSP </span>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType4}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span title={props.Details?.isCSP ? "CSP Partner" : "No CSP Partner"}>
                :&nbsp;{" "}
                {props.Details?.isCSP === false ? (
                  <CloseIcon
                    titleAccess="false"
                    sx={{
                      color: "red",
                      fontSize: "1.3rem"
                    }}
                    className={PartnerDetailsStyles.IconStyle}
                  />
                ) : (
                  <CheckIcon
                    titleAccess="true"
                    sx={{
                      color: "green",
                      fontSize: "1.3rem"
                    }}
                    className={PartnerDetailsStyles.IconStyle}
                  />
                )}
              </span>
            </Stack>
          )}
        </Stack>
        <Stack horizontal tokens={stackTokens}>
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType3}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span className={PartnerDetailsStyles.StackStyleType2}>IsPAL </span>
            </Stack>
          )}
          {props.loading ? (
            <Shimmer
              className={PartnerDetailsStyles.ShimmerStylesType4}
              shimmerColors={{
                shimmer: shimmerColor
              }}
            />
          ) : (
            <Stack styles={labelStyles}>
              <span title={props.Details?.isPAL ? "PAL Partner" : "No PAL Partner"}>
                :&nbsp;{" "}
                {props.Details?.isPAL === false ? (
                  <CloseIcon
                    titleAccess="false"
                    sx={{
                      color: "red",
                      fontSize: "1.3rem"
                    }}
                    className={PartnerDetailsStyles.IconStyle}
                  />
                ) : (
                  <CheckIcon
                    titleAccess="true"
                    sx={{
                      color: "green",
                      fontSize: "1.3rem"
                    }}
                    className={PartnerDetailsStyles.IconStyle}
                  />
                )}
              </span>
            </Stack>
          )}
        </Stack>
      </div>
    </>
  );
}
